import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import Certificates from './pages/Certificates';
import Careers from './pages/Careers';
import HardwareInstallation from './pages/services/HardwareInstallation';
import NetworkSetup from './pages/services/NetworkSetup';
import SystemMaintenance from './pages/services/SystemMaintenance';
import TechnicalSupport from './pages/services/TechnicalSupport';
import ServerManagement from './pages/services/ServerManagement';
import DataRecovery from './pages/services/DataRecovery';
import SecuritySolutions from './pages/services/SecuritySolutions';
import CloudServices from './pages/services/CloudServices';
import GetQuote from './pages/GetQuote';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/services/hardware-installation" element={<HardwareInstallation />} />
          <Route path="/services/network-setup" element={<NetworkSetup />} />
          <Route path="/services/system-maintenance" element={<SystemMaintenance />} />
          <Route path="/services/technical-support" element={<TechnicalSupport />} />
          <Route path="/services/server-management" element={<ServerManagement />} />
          <Route path="/services/data-recovery" element={<DataRecovery />} />
          <Route path="/services/security-solutions" element={<SecuritySolutions />} />
          <Route path="/services/cloud-services" element={<CloudServices />} />
          <Route path="/quote" element={<GetQuote />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
